import * as Styled from './styled'
import { TABS, getTabsData } from './config'
import { useCallback, useEffect } from 'react'
import { dispatch } from 'store'
import { aiLibThunks } from 'store/features/aiLibVideo/thunks'
import { aiLibImageThunks } from 'store/features/aiLibImage/thunks'
import { FlatTabbar } from 'common-components'
import { aiLibSelectors } from 'store/features/aiLibVideo/selectors'
import { useSelector } from 'react-redux'
import FilterTrigger from './FilterTrigger'

const AiLibContent: React.FC = () => {
  const tabsData = getTabsData()
  const activeTab = useSelector(aiLibSelectors.activeTab)

  const handleTabClick = useCallback(
    (tab: string) => {
      if (tab !== activeTab) {
        dispatch(aiLibThunks.setActiveTab(tab))
      }
    },
    [activeTab]
  )

  useEffect(() => {
    dispatch(aiLibThunks.closeFilters())
    dispatch(aiLibImageThunks.closeFilters())
    // Full, un-origin'd models catalog for the History filter (avatar included).
    // Guarded + cached, so re-opening the tab is a no-op.
    dispatch(aiLibThunks.getAllModels())
  }, [])

  return (
    <Styled.AiLibContainer>
      <Styled.Header>
        <Styled.TabbarWrapper>
          <FlatTabbar
            dataWithTexts={tabsData}
            defaultActiveTabName={activeTab}
            onCurrentItemClick={handleTabClick}
          />
        </Styled.TabbarWrapper>
        <FilterTrigger />
      </Styled.Header>
      {TABS.map(tab =>
        tab.key === activeTab ? (
          <Styled.AILibContentWrapper key={tab.key} $isActive>
            {tab.content}
          </Styled.AILibContentWrapper>
        ) : null
      )}
    </Styled.AiLibContainer>
  )
}

export default AiLibContent
